import React, {useEffect, useRef, useState} from 'react';
import useAxiosIntercept from "../../hooks/useAxiosIntercept";
import CustomerAssignPackage from "./CustomerAssignPackage";
import useAuth from "../../hooks/useAuth";
import AddCustomerPop from "./AddCustomerPop";

function VechicleListing({user_id, name}) {
    const runEffect = useRef(true);
    const axiosPrivate = useAxiosIntercept();
    const [vehicles, setVehicles] = useState([]);
    const [showAssignPackagePop, setShowAssignPackagePop] = useState(false);
    const [showAssignPackage, setShowAssignPackage] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const getVehicleList = async () =>{
        try{
            let url = process.env.REACT_APP_GET_USER_VEHICLE_MEMBER;
            url = url + `&user_id=${user_id}`+`&limit=9999`+`&show_energy_info=1`+`&show_package_info=1`+`&show_booking_info=1`+`&show_partner_vehicles=1`;
            const response = await axiosPrivate.get(url);
            console.log(response?.data?.response);
            if(response?.data?.response?.data){
                if(response?.data?.response?.data?.user_vehicles){
                    return(response?.data?.response?.data?.user_vehicles);
                }
                else{
                    return [];
                }
            }
            else{
                console.log("something went wrong");
            }
        }
        catch (error){
            console.log(error);
        }

    }

    useEffect(()=>{
        if(runEffect.current){
            runEffect.current = false;
            getVehicleList().then((data)=>{
                setVehicles(data);
            });
        }



    },[])

    let updateVehiclePackageData = ()=>{
        getVehicleList().then((data)=>{
            setVehicles(data);
        });
    }

    return (
        <>
            <h4 className="mb-24">Vehicle details</h4>
            {vehicles != null && vehicles.length != 0 ?
                (<>
                { vehicles.map((data)=>{
                    return(
                        <>
                        <section>
                            <div className="head">
                                <p>
                                    <img
                                        src={data.variant_image}
                                        alt=""
                                    />
                                </p>
                                <div className="headindTxt">
                                    <p>
                                        <span>{data.model_name} {data.variant_name}</span>
                                        {/* <span>Price- $20</span> */}
                                    </p>
                                    <ul className="tabsList">
                                        <li>{data.registration_no}</li>
                                    </ul>
                                    <span className="nextLine subHeading">
                                        {data.brand_name} {data.model_name} {data.variant_name} {data.variant_year}
                                    </span>
                                </div>

                                {data.package_info == null &&

                                <div href="javascript:void(0);"
                                     className="actionNav"
                                     onClick={()=>{
                                        setShowAssignPackage(prevState => !prevState);
                                     }}
                                >
                                    <i className="material-symbols-rounded mt-m grey">
                                        more_vert
                                    </i>
                                    {showAssignPackage &&
                                        <div className="dropMenuWrap">
                                            <ul className="dropMenu" style={{ width: 180 }}>
                                                <li onClick={()=>{
                                                    setShowAssignPackagePop(true);
                                                }}>
                                                    <a
                                                        className="open_model"
                                                        data-target="assignPackage"
                                                        href="javascript:void(0);"
                                                    >
                                                        Assign a package
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    }
                                </div>
                                }

                                {/* <a href="javascript:void(0);" class="actionNav">
                                      <i class="material-symbols-rounded mt-m grey">more_vert</i>
                                  </a> */}
                            </div>
                            <div className="dataTable">
                                <div>
                                    <p>
                                        <span>Battery</span>
                                        <span>{data.battery_capacity} KWH</span>
                                    </p>
                                   
                                    {
                                data.package_info ? (
                                  data.package_info.map((plandata) => {
                                    return (
                                      <p>
                                        <span>{plandata.package_group=="normal"?"Current plan":"Recovery insurance"}</span>
                                        {data.package_info ? (
                                          <>
                                            
                                              <span>
                                                {plandata.package_name}
                                              </span>
                                          </>
                                        ) : (
                                          <>
                                            <span>N/A</span>
                                          </>
                                        )}
                                      </p>
                                    )
                                  })
                                )

                                  : <>
                                  <p>
                                        <span>Current plan</span>
                                       
                                            <span>N/A</span>
                                          
                                        
                                      </p>
                                  </>
                              }

                                    {/* <p class="moreInfoBtn">
                                          <i class="material-symbols-rounded arrowTop mt-l">expand_more</i>
                                      </p> */}
                                </div>
                            </div>
                        </section>
                        {showAssignPackagePop && <CustomerAssignPackage close={()=>{setShowAssignPackagePop(false)}} user_id={user_id} name={name} data={data} setSuccessMessage={(data)=>setSuccessMessage(data)} update={updateVehiclePackageData}/>}
                        {successMessage && <AddCustomerPop message={successMessage} close={()=>setSuccessMessage('')}/>}
                        </>
                    )
                        })
                }
                </>)
                :
                <section> No Vehicles Found</section>
            }
        </>
    );
}

export default VechicleListing;